module.exports = __webpack_public_path__ + "img/bill-card.cfa5e9f4.svg";